module.exports = __webpack_public_path__ + "img/import.fd12738f.svg";